import React from 'react';
import { SystemConfig } from '@/types';
import { FileText, RefreshCw } from 'lucide-react';
import { SimpleEditor } from './settingsShared';

interface CertificateSectionProps {
  config: SystemConfig;
  onUpdate: (config: SystemConfig) => void;
  onRestoreDefaults: () => void;
  canEdit: boolean;
}

export const CertificateSection: React.FC<CertificateSectionProps> = ({
  config,
  onUpdate,
  onRestoreDefaults,
  canEdit
}) => (
  <div className="animate-fade-in p-2">
    <div className="mb-6 flex justify-between items-end">
      <div>
        <h4 className="font-bold text-lg text-slate-800 flex items-center gap-2">
          <FileText className="w-5 h-5 text-teal-600" /> Certificate Template
        </h4>
        <p className="text-xs text-slate-500 font-medium">
          Use HTML to customize the appearance of medical outcomes.
        </p>
      </div>
      <button
        onClick={onRestoreDefaults}
        className="bg-white border border-slate-200 text-slate-600 px-4 py-2 rounded-xl text-xs font-bold hover:bg-slate-50 flex items-center gap-2 shadow-sm transition-all"
      >
        <RefreshCw className="w-3 h-3" /> Restore Default HTML
      </button>
    </div>
    <SimpleEditor
      value={config.templates.certificateTemplate.body}
      onChange={(val) =>
        onUpdate({
          ...config,
          templates: {
            ...config.templates,
            certificateTemplate: { ...config.templates.certificateTemplate, body: val }
          }
        })
      }
      disabled={!canEdit}
    />
  </div>
);
